import { Component } from '@angular/core';
import { EventService } from '../core/services/event.service';
import { RootReducerState } from '../store';
import { Store } from '@ngrx/store';
import { LayoutState } from '../../app/store/layouts/layout-reducers';
import { Subscription } from 'rxjs';
import { AppSignalRService, SendMessageRequest } from '../core/services/signal-r.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthFacadeService } from '../core/services/auth-facade.service';
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent {

  // layout related config
  layoutType!: string;
  showMain: any;
  initialAppState!: LayoutState;
  private subscriptions: Subscription = new Subscription();
  private currentUserId: number | null = null;

  constructor(
    private eventService: EventService,
    private store: Store<RootReducerState>,
    private signalRService: AppSignalRService,
    private snackBar: MatSnackBar,
    private authfacadeService: AuthFacadeService,
  ) { }

  ngOnInit() {
    this.store.select('layout').subscribe((data) => {
      this.layoutType = data.LAYOUT;
      document.documentElement.setAttribute('data-layout', data.LAYOUT);
      data.LAYOUT == "vertical" || data.LAYOUT == "twocolumn" ? document.documentElement.setAttribute('data-sidebar', data.SIDEBAR_COLOR) : '';
      data.LAYOUT == "vertical" ? document.documentElement.setAttribute('data-sidebar-size', data.SIDEBAR_SIZE) : '';
      document.documentElement.setAttribute('data-bs-theme', data.LAYOUT_MODE);
      document.documentElement.setAttribute('data-layout-width', data.LAYOUT_WIDTH);
      document.documentElement.setAttribute('data-sidebar-image', data.SIDEBAR_IMAGE);
      document.documentElement.setAttribute('data-layout-position', data.LAYOUT_POSITION);
      document.documentElement.setAttribute('data-layout-style', data.SIDEBAR_VIEW);
      document.documentElement.setAttribute('data-topbar', data.TOPBAR);
      document.documentElement.setAttribute('data-preloader', data.DATA_PRELOADER)
      document.documentElement.setAttribute('data-theme', data.LAYOUT_THEME)

      if (document.documentElement.getAttribute('data-preloader') == 'enable') {
        setTimeout(() => {
          (document.getElementById("preloader") as HTMLElement).style.opacity = "0";
          (document.getElementById("preloader") as HTMLElement).style.visibility = "hidden";
        }, 1000);
      }

    })

    // Get current user ID for message filtering
    this.subscriptions.add(
      this.authfacadeService.profile$.subscribe(profile => {
        this.currentUserId = profile?.id || null;
      })
    );

    // Initialize SignalR connection and message handling
    this.subscriptions.add(
      this.signalRService.startConnection().subscribe(() => {
        this.subscriptions.add(
          this.signalRService.receiveMessage().subscribe((message: SendMessageRequest) => {
            // Only show notification if message is for current user
            if (this.currentUserId && message.receiverId === this.currentUserId) {
              this.authfacadeService.addIncomingMessage(message);

              // Show notification only if not in chat page
              if (!window.location.pathname.includes('/chats')) {
                this.snackBar.open(`New message from ${this.getSenderName(message)}`, 'View', {
                  duration: 5000,
                  panelClass: 'info',
                  horizontalPosition: 'right',
                  verticalPosition: 'top',
                }).onAction().subscribe(() => {
                  // Navigate to chat page
                  window.location.href = '/chats';
                });
              }
            }
          })
        );
      })
    );
  }

  private getSenderName(message: SendMessageRequest): string {
    // Try to get sender name from chat users
    const chatUsers = this.authfacadeService.chatUsers$;
    // For now, return a generic name - you can enhance this by accessing the store
    return 'Someone';
  }

  /**
  /**
  * Check if the vertical layout is requested
  */
  isVerticalLayoutRequested() {
    return this.layoutType === 'vertical';
  }

  /**
   * Check if the horizontal layout is requested
   */
  isHorizontalLayoutRequested() {
    return this.layoutType === 'horizontal';
  }

  /**
   * Check if the horizontal layout is requested
   */
  isTwoColumnLayoutRequested() {
    return this.layoutType === 'twocolumn';
  }

  getLayoutRequest(): string {
    return this.layoutType
  }

  ngOnDestroy() {
      // Stop the SignalR connection when the component is destroyed
      this.subscriptions.add(
        this.signalRService.stopConnection().subscribe({
          next: () => console.log('Disconnected from SignalR'),
        })
      );
      this.subscriptions.unsubscribe();
    }
}
